import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const PickyourProducts = () => {
  const [produceDetails, setProduceDetails] = useState([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    axios
      .get('https://api.bakpoket.com/api/AdminContent/products/approved')
      .then((res) => {
        setProduceDetails(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  // Show either first 4 or all
  const visibleProducts = showAll ? produceDetails : produceDetails.slice(0, 4);

  return (
    <Wrapper>
      <div>
        <div className='container-fluid py-2 py-lg-3 px-1 px-lg-0' style={{ backgroundColor: '#f6f4f4' }}>
          <div className='container d-flex justify-content-start '>
            <Content>
              <p>Pick Your Products </p>
            </Content>
          </div>
        </div>

        <div className='container'>
          <div className='row'>
            <div>
              <AdGrid>
                {visibleProducts.map((ad, idx) => (
                  <AdCard key={`ad-${ad.slotId ?? idx}`}>
                    {ad.imageData ? (
                      <div>
                        <a href={`https://${ad.merchantURL}`} target='_blank' rel='noopener noreferrer'>
                          <img src={ad.imageData} alt={`Ad Slot ${ad.slotId}`} style={{ width: '100%' }} />
                        </a>
                      </div>
                    ) : (
                      <Para>No Image Available</Para>
                    )}
                  </AdCard>
                ))}
              </AdGrid>
            </div>
          </div>

          {/* Show More / Show Less button */}
          {produceDetails.length > 4 && (
            <div className='d-flex justify-content-center'>
              <ShowMoreBtn className='rounded-2' onClick={() => setShowAll(!showAll)} >
                {showAll ? 'Show Less' : 'Show More'}
              </ShowMoreBtn>
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

export default PickyourProducts;

const ShowMoreBtn = styled.button`
  background-color: #2a4157 ;
  color: #fff;
  width: 140px;
  padding: 10px 20px;
  margin: 20px auto;
  display: block;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #ef4766;
  }
`;

const Wrapper = styled.section`
  h4 {
    margin-left: 30px;
  }

  @media (max-width: 576px) {
    h4 {
      margin-left: 0px;
    }
  }
`;


const AdGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 20px 90px;
  max-width: 1280px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 15px 30px;
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 5px;
    padding: 10px 0px;
  }
`;

const AdCard = styled.div`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
  padding: 5px;

  img {
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;

const Para = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  text-align: center;
  font-size: 10px;
`;

const Content = styled.div`
  width: 100%;
  max-width: 1280px;

  p {
    margin: 0;
    font-weight: bold;
    font-size: 20px;
    color: rgb(83, 83, 83);
  }

  @media (max-width: 768px) {
    p {
      font-size: 16px;
    }
  }

  @media (max-width: 480px) {
    padding: 0 5px;
    p {
      font-size: 14px;
    }
  }
`;
